export default {
  vgn: {
    name: 'Vegano',
    emoji: '🌱',
  },
  vgt: {
    name: 'Vegetariano',
    emoji: '🥬',
  },
  gf: {
    name: 'Sin gluten',
  },
  df: {
    name: 'Sin lácteos',
  },
  hal: {
    name: 'Halal',
  },
  'h&s': {
    name: 'Picante',
    emoji: '🌶',
  },
};
